import { todayIsoDateLocal } from '../../../utils/caseFieldValidation';

export function isHighUrgencyLevel(name: string): boolean {
  return name.trim().toLowerCase().includes('high');
}

export function minDeadlineDateForRightToInformation(): string {
  return todayIsoDateLocal();
}

function isValidEmail(value: string): boolean {
  const t = value.trim();
  if (!t) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t);
}

export function emailAddressError(value: string): string | undefined {
  if (!value.trim()) return undefined;
  return isValidEmail(value) ? undefined : 'Enter a valid email address.';
}

export function preferredAccessLabels(
  ids: string[],
  options: { id: string; name: string }[],
): string[] {
  return ids.map((id) => options.find((o) => o.id === id)?.name ?? '').filter(Boolean);
}

/**
 * Localized display label for a preferred-method-of-access option.
 *
 * The option list is backend master data (English). This translates only the
 * on-screen label by matching the English name; the value submitted to the API
 * (ids/names) is unaffected. Falls back to the original name if unmatched.
 */
export function translatePreferredAccessName(name: string, t: (key: string) => string): string {
  const n = name.toLowerCase();
  if (n.includes('inspect')) return t('rti.preferredAccess.inspectInPerson');
  if (n.includes('sample')) return t('rti.preferredAccess.certifiedSamples');
  if (n.includes('copies') || n.includes('copy')) return t('rti.preferredAccess.receiveCopies');
  if (n.includes('digital') || n.includes('printed')) return t('rti.preferredAccess.digitalOrPrinted');
  return name;
}
